import React from 'react';

import './subscription-card-shimmer.m.css';

const SubscriptionCardShimmer = ({ churnUser, isCard }) => {
  const first = churnUser ? 'heading' : 'extra-large';
  const second = churnUser ? 'heading-large' : 'large';
  const third = churnUser ? 'heading-small' : 'small';
  return (
    <div styleName={`hardpaywall-wrap-skeleton ${isCard ? 'card-section-wrap' : ''}`}>
      {!isCard && (
        <div styleName="skeleton">
          <div styleName={first}></div>
          <div styleName={second}></div>
          <div styleName={third}></div>
        </div>
      )}
      <div styleName="subscription-wrap">
        {!isCard && <div styleName="divider-line"></div>}
        <div styleName="card-section">
          {churnUser ? (
            <div styleName="churn-user">
              {Array.apply(null, Array(2)).map((list, index) => (
                <div styleName="card" key={index}>
                  <div styleName="card-header">
                    <img
                      src="/icons/ic_radio_button_unchecked_24px.svg"
                      height="23px"
                      width="23px"
                    />
                    <div styleName="title">
                      <div styleName="name"></div>
                      <div styleName="amount"></div>
                    </div>
                  </div>
                  <div styleName="card-footer">
                    <div styleName="duration-skeleton"></div>
                    <div styleName="amount-skeleton"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div styleName="main-card">
              {Array.apply(null, Array(3)).map((list, index) => (
                <div styleName="card" key={index}>
                  <div styleName="card-header">
                    <img
                      src="/icons/ic_radio_button_unchecked_24px.svg"
                      height="23px"
                      width="23px"
                    />
                    {index === 1 && <div styleName="label-ss"></div>}
                  </div>
                  <div styleName="card-footer">
                    <div styleName="duration-skeleton"></div>
                    <div styleName="amount-skeleton"></div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {!isCard && (
            <div styleName="skeleton">
              <div styleName="extra-large"></div>
              <div styleName="small"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCardShimmer;
